import { TFunction } from "next-i18next";

import { DeliveryMethod } from "../constants";
import { TDeliveryMethod } from "../types";

// These are hardcoded delivery methods used in application. Value must be the same like used in /offer endpoint
// List is defined in same order in which delivery method needs to be displayed for user
const getDeliveryMethods = (t: TFunction): TDeliveryMethod[] => [
  {
    value: DeliveryMethod.PudoToPudo,
    label: t("order-delivery_method-pudo_pudo"),
  },
  {
    value: DeliveryMethod.DoorToDoor,
    label: t("order-delivery_method-door_door"),
  },
  {
    value: DeliveryMethod.DoorToPudo,
    label: t("order-delivery_method-door_pudo"),
  },
  {
    value: DeliveryMethod.PudoToDoor,
    label: t("order-delivery_method-pudo_door"),
  },
];
export default getDeliveryMethods;
